/**
 * Common event handlers for chart files
 * Handles view table toggle, view results, and modal events
 */

(function($) {
	// Initialize common event handlers
	function initializeChartEventHandlers() {
		// Object to keep track of charts
		var charts = {};
		
		// View table toggle handler
		$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');
		
		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		// Instantly toggle the table's visibility
		dataTable.toggle();

		// Use a minimal timeout to allow the DOM to update after the toggle.
		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20; // Account for sticky headers or other offsets

			// Determine the target element and button text based on visibility
			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable; // Our target is the table itself
			} else {
				$button.text('View Table');
				$targetElement = card; // Our target is the card containing the chart
			}
            
            // This is a robust way to calculate the required scroll position.
            var currentScrollTop = $scrollContainer.scrollTop();
            var targetTop = $targetElement[0].getBoundingClientRect().top;
            var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;
            
            var scrollOffset = targetTop - containerTop - headerOffset;
            var newScrollTop = currentScrollTop + scrollOffset;
			
			// Jump instantly to the calculated position.
			$scrollContainer.scrollTop(newScrollTop);
			
		}, 10); // Using a 10ms timeout should be sufficient for reflow.

		// This is part of a hack for the modal height to make it work across browsers
		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});
	
	// View results handler
	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = window.location.href.split('/projects/');
		if (projectPath.length > 1) {
			// Extract the slug portion, removing any trailing hashtags or other parts
			let currentProjectID = projectPath[1].split(/[?#]/)[0]; // Split by '?' or '#' and take the first part
			if (window.WebAssessmentCharts && window.WebAssessmentCharts.fetchDataAndCalculateScores) {
				window.WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
			}
		}
	});
	
	// Auto-reopen View Results modal after mark-complete reload
	if (sessionStorage.getItem('openViewResultsAfterReload') === '1') {
		sessionStorage.removeItem('openViewResultsAfterReload');
		var viewResultsEl = document.getElementById('viewResultsModal');
		if (viewResultsEl) {
			$('.modal-body .loader').show();
			var bsModal = new bootstrap.Modal(viewResultsEl);
			bsModal.show();
			var projectPath = window.location.href.split('/projects/');
			if (projectPath.length > 1) {
				var currentProjectID = projectPath[1].split(/[?#]/)[0];
				if (window.WebAssessmentCharts && window.WebAssessmentCharts.fetchDataAndCalculateScores) {
					window.WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
				}
			}
			$('.dashboard-selection').trigger('change');
		}
	}

	// Project complete modal handler
	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		let currentProjectID = '';
		let viewResultsProject = window.location.href;
		
		// Check if there's a hash in the URL
		if (viewResultsProject.includes('#')) {
			currentProjectID = viewResultsProject.split('#')[1];
		}
		
		// Extract the project ID from the URL path if it's not available from the hash
		if (!currentProjectID) {
			const projectPath = viewResultsProject.split('/projects/');
			if (projectPath.length > 1) {
				currentProjectID = projectPath[1];  // Extract the part after '/projects/'
			}
		}
		
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			if (window.WebAssessmentCharts && window.WebAssessmentCharts.fetchDataAndCalculateScores) {
				window.WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
			}
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = initializeChartEventHandlers;
	} else if (typeof window !== 'undefined') {
		window.initializeChartEventHandlers = initializeChartEventHandlers;
	}

})(jQuery);
